/**
 * Pearla 品牌 - Welfare 页面配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

/**
 * Pearla 品牌特定主题配置
 */
export const theme = {
  // 按钮背景色
  btnBg: '#F5F0FF',
  // 按钮文本颜色 (使用主色)
  btnText: brandTheme.primaryColor,
  // 金币颜色 (使用主色)
  coinsColor: brandTheme.primaryColor,
  // 金币数量渐变色
  coinsGradient: '#FFFFFF',
  // 通用渐变色（任务按钮、弹窗按钮）
  actionGradient: brandTheme.primaryGradient,
  // Check-in 按钮渐变色
  checkinBtnGradient: 'linear-gradient(315deg, #7761F7 0%, #F992FF 100%), #FD9540',
} as const

/**
 * Pearla 品牌特定资源配置
 */
export const resources = {
  // 首页背景图
  homeBg: '/images/pearla/welfare-bg.webp',
  // 金币图标
  welfareGold: '/images/pearla/welfare-gold.png',
  // 宝箱图标
  welfareBox: '/images/pearla/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
